<template>
  <div class="content">
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{mode}} class</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <tabs
            ref="tabs1"
            tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper"
            tabContentClasses="card shadow"
          >
            <tab-pane id="main">
              <span slot="title">Main</span>
              <validation-observer ref="classformvalid">
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        type="text"
                        rules="required"
                        label="Class code"
                        placeholder="Code"
                        v-model="cls.code"
                        name="Code"
                      ></base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Course" rules="required" name="course">
                        <span v-if="mode === 'Edit'">{{cls.coursetitle}}</span>
                        <el-select
                          v-if="mode === 'Create'"
                          class="select-primary pagination-select"
                          v-model="cls.courseId"
                          placeholder="Course"
                        >
                          <el-option
                            class="select-primary"
                            v-for="item in courses"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input label="Start date" rules="required" name="start date">
                        <flat-picker
                          :config="{allowInput: true}"
                          class="form-control datepicker"
                          v-model="cls.startdate"
                        ></flat-picker>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="End date">
                        <flat-picker
                          :config="{allowInput: true, minDate: cls.startdate }"
                          class="form-control datepicker"
                          v-model="cls.enddate"
                        ></flat-picker>
                      </base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input label="Responsible" rules="required" name="Responsible">
                        <el-select
                          class="select-primary pagination-select"
                          v-model="cls.respperson"
                          placeholder="Teacher"
                        >
                          <el-option
                            class="select-primary"
                            v-for="item in users"
                            :key="item.id"
                            :label="item.fullname"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </base-input>
                    </div>
                  </div>
                </div>
              </validation-observer>
              <div class="pl-lg-4">
                <base-button block type="primary" @click.native="onSave">Save changes</base-button>
              </div>
            </tab-pane>

            <tab-pane id="student" :disabled="!cls.id">
              <span slot="title">Students</span>
              <students :classId="classId" :classStartDate="cls.startdate"></students>
            </tab-pane>

            <tab-pane id="lesson" :disabled="!cls.id">
              <span slot="title">Lessons</span>
              <lessons :classId="classId" :classStartDate="cls.startdate"></lessons>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { GetClass, Create, Update } from "../../../services/classes";
import { GetActiveCourses } from "../../../services/courses";
import { GetTeachers } from "../../../services/user";
import { ClassType } from "../../../services/types";
import { Tabs, TabPane } from "@/components";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Students from "./Students";
import Lessons from "./Lessons";
export default {
  components: {
    Tabs,
    TabPane,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    Students,
    Lessons,
    flatPicker,
  },
  props: {
    id: String,
  },
  computed: {
    mode() {
      return this.classId ? "Edit" : "Create";
    },
  },
  data() {
    return {
      isLoading: false,
      classId: this.id,
      cls: {},
      users: [],
      courses: [],
    };
  },
  methods: {
    onSave() {
      this.$refs.classformvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          if (this.mode === "Create") {
            Create(this.cls).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.classId = response.data.result;
                this.cls.id = response.data.result;
                this.notifyVue("success");
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          } else {
            Update(this.cls).then((response) => {
              if (response.data.result) {
                this.notifyVue("success");
              } else {
                this.notifyVue("danger", response.data);
              }
              this.isLoading = false;
            });
          }
        }
      });
    },
  },
  mounted() {
    GetTeachers().then((response) => {
      if (response.data !== null) {
        this.users = response.data.result;
      }
    });

    GetActiveCourses().then((response) => {
      if (response.data !== null) {
        this.courses = response.data.result;
      }
    });
  },
  created() {
    if (this.mode === "Create") {
      this.cls = new ClassType();
    } else {
      this.isLoading = true;
      GetClass(this.classId).then((response) => {
        this.isLoading = false;
        if (response.data.result !== undefined) {
          this.cls = response.data.result;
        } else {
          this.notifyVue("danger", response.data);
        }
      });
    }
  },
};
</script>
